<script setup lang="js">

import {MapPinIcon, StarIcon, HeartIcon, BuildingOfficeIcon} from "@heroicons/vue/16/solid";
import TagComponent from "@/components/TagComponent.vue";
import LikeButtonComponent from "@/components/LikeButtonComponent.vue";
import CommentCountComponent from "@/components/shared/CommentCountComponent.vue";
import {useMiscStore} from "@/stores/misc";

const props = defineProps({
  business: {
    type: Object,
    default: () => {},
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
})
const misc = useMiscStore(),
    setCurrentSectorAndCategory = (sector, category) => {
      misc.setCurrentSector(sector);
      misc.setCurrentCategory(category);
};
</script>

<template>
  <div class="flex flex-col h-full min-h-[260px] max-h-[360px] drop-shadow-lg">
    <div class="px-4 pt-4">
      <h3 class="flex items-center text-yellow-200/70 text-left border-b pb-2 border-yellow-50/10 text-base font-medium">
        <StarIcon
          v-if="props.type === 'rated'"
          class="h-5 w-5 inline-block mr-2"
        />
        <HeartIcon
          v-if="props.type === 'voted'"
          class="h-5 w-5 inline-block mr-2"
        />
        Most {{ props.type }}
      </h3>
    </div>
    <div class="flex flex-col justify-between h-full flex-grow">
      <div
        class="p-4 w-full"
      >
        <div class="w-full mb-4">
          <h3
            class="h5 text-left"
          >
            <router-link
              :to="`/${props.business?.sector.slug.toLowerCase()}/${props.business?.category.slug.toLowerCase()}/${
                props.business?.id
              }`"
              target="_self"
              class="text-yellow-50 font-semibold hover:text-red-500 transition-all duration-500"
              @click="
                setCurrentSectorAndCategory(props.business?.sector, props.business?.category)
              "
            >
              {{ props.business?.name }}
            </router-link>
          </h3>
        </div>
        <div class="text-left mb-4">
          <div class="flex items-center justify-start">
            <BuildingOfficeIcon
              id="bookmark"
              data-toggle="tooltip"
              class="h-4 w-4 text-left text-yellow-300 cursor-pointer -ml-1 mr-1 inline"
              aria-hidden="true"
              style="cursor:pointer;"
            />
            <span class="text-gray-400">
              {{ props.business?.region?.name || 'N/A' }}/{{ props.business?.city?.name || 'N/A' }}
            </span>
          </div>
          <div class="flex items-center justify-start mt-1">
            <MapPinIcon
              id="bookmark"
              data-toggle="tooltip"
              class="h-4 w-4 text-left text-green-700 cursor-pointer -ml-1 mr-0.5 inline"
              aria-hidden="true"
              style="cursor:pointer;"
            />
            <span class="text-xs text-gray-400 text-justify font-semibold overflow-hidden whitespace-nowrap overflow-ellipsis">
              {{ props.business?.address }}
            </span>
          </div>
        </div>
        <div class="text-right">
          <router-link
            :to="{
              name: 'Category',
              params: {
                sector: props.business?.sector.name.toLowerCase(),
                category: props.business?.category.name.toLowerCase(),
              },
            }"
            class="tag self-center"
            @click="setCurrentSectorAndCategory(props.business?.sector, props.business?.category)"
          >
            <TagComponent
              :title="props.business?.category?.name"
              :class="`text-[.67rem] md:mt-2 rounded-md px-1.5 py-[2px]`"
              :bg-color="props.business?.category?.background"
              :color="props.business?.category?.color"
            />
          </router-link>
        </div>
      </div>
      <div class="w-full p-4">
        <div class="flex flex-col text-xs">
          <div class="flex flex-wrap justify-between items-center">
            <div class="items-center flex flex-grow no-more">
              <LikeButtonComponent
                :id="props.business?.id"
                :count="props.business?.likeCount"
                :user-has-liked="props.business?.liked"
                from="all"
              />
              <CommentCountComponent
                :id="props.business?.id"
                :count="props.business?.reviewCount"
                :user-has-reviewed="business?.reviewed"
                from="all"
              />
            </div>
            <div class="flex justify-end items-center flex-grow">
              <span class="text-gray-400/80 font-bold text-xs mr-md-2"> {{ props.business?.updatedAt }}</span>
              <router-link
                :to="`/users/${props.business?.creator.id}/businesses`"
              >
                <img
                  :src="props.business?.creator.profile.avatar"
                  class="w-7 h-7 rounded-full shadow-md mr-0 ml-2 text-success"
                  alt=""
                >
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>